// eslint-disable-next-line max-len
/* eslint-disable no-unused-vars,react/no-direct-mutation-state,react/state-in-constructor,react/prop-types,react/destructuring-assignment,react/jsx-filename-extension */
import React, { Component } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import SnackbarContent from '@mui/material/SnackbarContent';
import { CheckCircle, Error } from '@mui/icons-material';

class Alerts extends Component {
    state = {
      isActive: false,
      message: null,
      cssClass: null,
      actions: [],
    };

    clearAlertContent = () => {
      this.state.message = null;
      this.state.cssClass = null;
      this.state.icon = null;
      this.state.actions = [];
    };

    render() {
      const { alertState, handleRequestClose, message, actions } = this.props;
      const normalizedActions = Array.isArray(actions)
        ? actions
        : actions
          ? [actions]
          : [];
      switch (alertState) {
        case 'success':
          this.state.isActive = true;
          this.state.message = message;
          this.state.cssClass = 'mb-3 alertSuccess alertSpacing';
          this.state.icon = <CheckCircle className='icon' />
          this.state.actions = normalizedActions;
          break;
        case 'failure':
          this.state.isActive = true;
          this.state.message = message;
          this.state.cssClass = 'mb-3 alertFailure alertSpacing';
          this.state.icon = <Error className='icon' />
          this.state.actions = normalizedActions;
          break;
        case 'warning':
          this.state.isActive = true;
          this.state.message = message;
          this.state.cssClass = 'mb-3 alertWarning alertSpacing';
          this.state.actions = normalizedActions;
          break;
        case 'information':
          this.state.isActive = true;
          this.state.message = message;
          this.state.cssClass = 'mb-3 alertInformation alertSpacing';
          this.state.actions = normalizedActions;
          break;
        case 'close':
          this.state.isActive = false;
          break;
        default:
          this.state.isActive = false;
      }
      return (
        <div>
          <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.isActive}
          autoHideDuration={15000}
          onClose={handleRequestClose}
          TransitionComponent={Fade}
          transitionDuration={{ enter: 200, exit: 300 }}
          onExited={this.clearAlertContent}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
        >
          <div
            className={this.state.cssClass}
            style={{ display: 'flex', alignItems: 'center', gap: 16 }}
          >
            {this.state.icon}
            <div style={{ flex: 1 }}>{this.state.message}</div>
            {this.state.actions.map((action, index) => (
              <Button
                key={`${action?.label || 'action'}-${index}`}
                color="inherit"
                variant="outlined"
                onClick={action?.onClick}
                sx={{
                  borderColor: 'currentColor',
                  color: 'inherit',
                  textTransform: 'none',
                  minWidth: 'fit-content',
                  whiteSpace: 'nowrap',
                  backgroundColor: 'white',
                }}
              >
                {action?.label}
              </Button>
            ))}
            <IconButton
              sx = {
                {
                  marginLeft: -1.5
                }
              }
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={handleRequestClose}
            >
              <CloseIcon />
            </IconButton>
          </div>

        </Snackbar>

        </div>
      );
    }
}

export default Alerts;
